module.exports = __webpack_public_path__ + "static/media/FamilyLaw.cd216fa8.jpg";